<template>
  <div ref="vesselContainerOverview" class="vessel-container-overview vs-con-loading__container">
    <template v-if="size !== 'small'">
      <!-- small 以外のヘッダ-->
      <vs-row  class="container-list-header">
        <vs-col class="flex justify-start items-center col-width-vessel-name-last-updated-at">
          
          <vs-row class="vessel-name-last-updated-at">
            <vs-col class="flex justify-start items-center col-width-vessel-name">
              <!-- 船名 -->
              <div class="aisea-text-20-400-black vessel-name">{{ enterpriseVessel.name }}</div>
            </vs-col>
            <vs-col 
              class="flex items-center col-width-last-updated-at last-updated-at"
              :class="[ (getDeviceInfo().deviceType === 'iPhone' && getDeviceInfo().deviceOrientation === 'portrait' ) ? 'justify-start' : 'justify-end'] "
            >
              <!-- 最終更新日時 -->
              <span class="aisea-text-12-400-black">{{ last_updated_at }}</span>
            </vs-col>
          </vs-row>


        </vs-col>
        <vs-col class="flex justify-end items-start col-width-detail-button">
          <!-- コンテナ詳細遷移ボタン -->
          <vs-button
            class="border-button detail-page-button"
            :color="AISEA_COLOR.PURE_WHITE"
            @click="goToVesselContainerDetails(enterpriseVessel)"
          >              
            <div class="button-inner flex items-center" >
              <feather-icon class="mr-2" icon="GridIcon" svgClasses="h-5 w-5"/>
              <div class="aisea-text-14-400-blue">コンテナ詳細</div>
            </div>
          </vs-button>
        </vs-col>
      </vs-row>

    </template>
    <template v-else>
      <!-- small の場合のヘッダ -->
      <vs-row vs-type="flex" vs-w="12"  class="container-list-header-small">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="6"
        >
          <span class="aisea-text-14-700-black">{{ size === 'small' ? 'コンテナ稼働状況' : enterpriseVessel.name }}</span>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="6"
        >
          <span class="aisea-text-12-400-black">{{ last_updated_at }}</span>
        </vs-col>

      </vs-row>
    </template>

    <vs-row 
      class="flex justify-start"
      :style="{margin: ( device === 'iPhone' || device === 'iPad' && getDeviceInfo().deviceOrientation === 'portrait' ) ? '0.6rem 0.5rem' : null}"
      :class="[ 
         ( device !== 'iPhone' && device !== 'iPad' ) ? ( size === 'small' ? 'position-container-summary-small'  : 'position-container-summary'  ) : null,
         ( device !== 'iPhone' && device !== 'iPad' ) ? ( size === 'small' ? 'col-width-container-summary-small' : 'col-width-container-summary' ) : null,
      ]" 
    >

      <vs-col
        class="flex justify-start items-center"
      >
        <!-- コンテナ集計情報 -->
        <container-status-count-view
          ref="containerStatusCountView"
          :counts="counts"
        />
      </vs-col>
    </vs-row>


    <vs-row vs-type="flex" vs-w="12" >
      <div id="container-list" >      

        <!-- コンテナ一覧 -->
        <vs-col
          v-for="container_info in enterprise_vessel_containers"
          :key="container_info.id"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          :style="cardWidthByDevice"
          style="padding: 0;"
        >
          <!-- 各コンテナカード -->
          <container-status
            :container_info="container_info"
            :size="size"
          ></container-status>
        </vs-col>
      </div>
    </vs-row>


  </div>
</template>

<script>
import ContainerStatus from "./components/ContainerStatus.vue";
import ContainerStatusCountView from "./components/ContainerStatusCountView.vue";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("ecoShip");
import moment from "moment-timezone";


export default {
  components: { ContainerStatus, ContainerStatusCountView },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    enterpriseVessel: { type: Object },
    size: { type: String, default: 'medium' },
  },
  data() {
    return {
      device: "PC",
      enterprise_vessel_containers: [],
      hanasysExperts: [],
      channels: [],
      counts: {
        container_count: 0,
        active_count: 0,
        alert_count: 0,
        interlock_count: 0,
        power_off_count: 0,
      },
      isLoading: true,
      last_updated_at: "",
      routerViewWidth: 1366,
    }
  },
  watch: {
    async hanasysExpertLastUpdatedAt() {
      // fireStoreの情報が更新されたら。
      this.summaryContainerStatus();
    },
    onChangeWindowSize() {
      const routerViewElement = document.getElementsByClassName("router-view");
      if ( routerViewElement ){
        this.routerViewWidth = routerViewElement[0].getBoundingClientRect().width;
      } else {
        this.routerViewWidth = document.documentElement.clientWidth - 260;
      }
    },
  },
  computed: {
    ...mapState({
      hanasysExpert: state => state.hanasysExpert,
      hanasysExpertLastUpdatedAt: state => state.hanasysExpertLastUpdatedAt,
    }),
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    cardWidthByDevice() {
      let widthMinMax = [];
      if ( this.size === 'small' ) {
        if ( this.device === 'iPhone' && this.getDeviceInfo().deviceOrientation === 'portrait' ) {
          widthMinMax = ['calc( 100% / 3 )', 'calc( 100% / 3 )'];
        } else if ( this.device === 'iPhone' && this.getDeviceInfo().deviceOrientation === 'landscape' ) {
          if ( this.getDeviceInfo().width <= 667 ) {
            // iPhone8
            widthMinMax = ['calc( 100% / 6 )', 'calc( 100% / 6 )'];
          } else {
            widthMinMax = ['calc( 100% / 6 )', 'calc( 100% / 6 )'];
          }
        } else if ( this.device === 'iPad' && this.getDeviceInfo().deviceOrientation === 'portrait' ) {
          widthMinMax = ['calc( 100% / 7 )', 'calc( 100% / 7 )'];
        } else if ( this.device === 'iPad' && this.getDeviceInfo().deviceOrientation === 'landscape' ) {
          widthMinMax = ['calc( 100% / 11 )', 'calc( 100% / 11 )'];
        } else {
          if ( this.routerViewWidth  <= 1286 ) {
            widthMinMax = ['calc( 100% / 11 )', 'calc( 100% / 11 )'];
          } else {
            widthMinMax = ['calc( 100% / 13 )', 'calc( 100% / 13 )'];
          }
        }
      }else {
        if ( this.device === 'iPhone' && this.getDeviceInfo().deviceOrientation === 'portrait' ) {
          widthMinMax = ['calc( 100% / 2 )', 'calc( 100% / 2 )'];
        } else if ( this.device === 'iPhone' && this.getDeviceInfo().deviceOrientation === 'landscape' ) {
          if ( this.getDeviceInfo().width <= 667 ) {
            // iPhone8 は 3カラム
            widthMinMax = ['calc( 100% / 3 )', 'calc( 100% / 3 )'];
          } else {
            widthMinMax = ['calc( 100% / 4 )', 'calc( 100% / 4 )'];
          }
        } else if ( this.device === 'iPad' && this.getDeviceInfo().deviceOrientation === 'portrait' ) {
          widthMinMax = ['calc( 100% / 4 )', 'calc( 100% / 4 )'];
        } else if ( this.device === 'iPad' && this.getDeviceInfo().deviceOrientation === 'landscape' ) {
          widthMinMax = ['calc( 100% / 6 )', 'calc( 100% / 6 )'];
        } else {
          if ( this.routerViewWidth  <= 1286 ) {
            widthMinMax = ['calc( 100% / 6 )', 'calc( 100% / 6 )'];
          } else {
            widthMinMax = ['calc( 100% / 7 )', 'calc( 100% / 7 )'];
          }
        }
      }

      return  {
                'min-width': widthMinMax[0],
                'max-width': widthMinMax[1],
              }
    },
  },
  methods: {
    ...mapActions([
      "fetchVesselContainers",
      "getChannelMaster",
      "getVersion",
      "getHanasysExpartData",
      "unsubscribeFirestore",
      "getVesselContainers",
    ]),

    summaryContainerStatus() {


      this.counts = {
        container_count: 0,
        active_count: 0,
        alert_count: 0,
        interlock_count: 0,
        power_off_count: 0,
      };

      // コンテナ数
      this.counts.container_count = this.enterprise_vessel_containers.length;

      // 各コンテナの状態カウント
      this.channels
        .filter((channel) => channel.category3_id === null)
        .map((channel) => channel.channel_id)
        .forEach((channel_id) => {
        const channel = this.hanasysExpert[channel_id];  // firestoreのデータ

        if ( channel && channel.properties ) {
          const properties = JSON.parse(channel.properties);
          if (properties.tag_status === "I") {
            if ( channel.vs === "NO-VOLT" ) {
              this.counts.power_off_count++;
            } else {
              this.counts.interlock_count++;
            }
          } else if (properties.tag_status === "A") {
            this.counts.alert_count++;
          } else if (channel.vs === 'RUN'){
            this.counts.active_count++;
          } else {
            this.counts.power_off_count++;
          }
        }
      });

      // 最終更新日時
      const last_updated_timestamp = this.hanasysExpert["last_updated_at"];  // firestoreのデータ
      if ( last_updated_timestamp ) {
        this.last_updated_at = moment(last_updated_timestamp.timestamp.seconds * 1000).local().format("YYYY/MM/DD HH:mm");
      }
    },

    goToVesselContainerDetails(enterpriseVessel) {
      this.$router.push({
        name: "addon-eco-ship-vessel-container-details",
        query: {
          id: enterpriseVessel.enterprise_vessel_id,
        },
      });
    },

  },
  created() {
    this.device = this.getDeviceInfo().deviceType;
  },
  async mounted() {

    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"

    this.isLoading = true;
    this.$vs.loading({ container: this.$refs.vesselContainerOverview });

    const vesselContainers = await this.getVesselContainers(this.enterpriseVessel);
    if ( vesselContainers ) {
      this.channels = vesselContainers.channels;
      this.enterprise_vessel_containers = vesselContainers.enterprise_vessel_containers;  // コンテナカードリストとして一覧表示. （軸）
      this.summaryContainerStatus();
    }

    this.$nextTick(() => {
      this.$vs.loading.close(this.$refs.vesselContainerOverview);
      this.isLoading = false;
    });
  },
  beforeDestroy() {
    this.unsubscribeFirestore();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
$width_vessel_name:     220px;
$width_last_updated_at: 130px;
$width_detail_button:   150px;

.vessel-container-overview {
  padding-bottom: 1rem;
}

#container-list {
  width: 100%;
}

.container-list-header {
  margin-top: 0.4rem;
}
.container-list-header-small {
  margin-top: 1.0rem;
}
.vessel-name-last-updated-at {
  margin-left: 0.4rem;
}
.vessel-name {
  width: calc(100% - 40px) !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  margin: 0;
  padding: 0.5rem 0;
}

.last-updated-at {
  margin: 0.4rem 0;
}


.col-width-vessel-name-last-updated-at {
  width: calc(100% - #{$width_detail_button}) !important;
}

.col-width-vessel-name {
  min-width: $width_vessel_name !important; 
  width: calc(100% - #{$width_last_updated_at}) !important;
}

.col-width-last-updated-at {
  width: $width_last_updated_at !important;
}

.col-width-detail-button {
  width: $width_detail_button !important;
}

.position-container-summary {
  position: relative; 
  top: -2.75rem; 
  left: calc(#{$width_vessel_name} + 14px );
}
.col-width-container-summary {
  width: calc(100% - #{$width_vessel_name} - #{$width_last_updated_at} - #{$width_detail_button} ) !important;
}

.position-container-summary-small {
  position: relative; 
  top: -2.0rem; 
  left: calc( #{$width_vessel_name} + 40px );
}
.col-width-container-summary-small {
  width: calc(100% - ( #{$width_vessel_name} - 140px ) - #{$width_last_updated_at} - #{$width_detail_button}) !important;
}

.button-inner {
  padding-top: 3px;
  top: -1.5rem; 
  left: calc( #{$width_vessel_name} - 80px );
}

.detail-page-button {
  padding:    10px !important;
  min-width: 140px !important;
}
</style>